import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { LandingLayout, Loading } from "../../components";
import {
	btnStyle,
	inputStyle,
	LandingTitle,
	otpStyle,
} from "../../lib/styles/styleLibrary";
import { Button, Image, Input, InputNumber, Statistic } from "antd";
import { ArrowLeftOutlined, EyeTwoTone } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import {
	forgotPin,
	resetPin,
	viewUserProfile,
} from "../../redux/actions/authentication";
import { PageLoading } from "../../components/Loading/Loading";
import Auth from "../../lib/middleware/auth";
import errorHandler from "../../redux/actions/errorHandler";
import { useMutation } from "react-query";
import lock from "../../assets/svg/lock.svg";
import pwd_hidden from "../../assets/svg/pwd_hidden_eye.svg";
import { ROUTES } from "../../settings/routes";
import { COLORS } from "../../lib/styles/styles";

const Wrapper = styled.div`
	${tw`sm:p-8! md:p-16! sm:max-w-md sm:mx-auto md:max-w-none md:mx-0`}

	@media (min-width: 769px) and (max-width: 1023px) {
		padding: 16px !important;
	}
`;

const ResetPin = (props) => {
	const history = useHistory();
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const emailParams = searchParams.get("email");
	const codeParams = searchParams.get("code");

	const user = Auth.getUser();
	const [resend, setResend] = useState(false);
	const [visible, setVisible] = useState(false);
	const [rc, rcl] = useState(false);
	const { Countdown } = Statistic;
	const [code, setCode] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	});
	const [walletPin, setWalletPin] = useState({
		new_pin: "",
		confirm_new_pin: "",
	});

	const inputfocus = (elmnt) => {
		if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
			const next = elmnt.target.tabIndex - 2;

			if (next > -1) {
				elmnt.target.form.elements[next].focus();
			}
		} else {
			const next = elmnt.target.tabIndex;
			if (next < 5) {
				elmnt.target.form.elements[next].focus();
			}
		}
	};

	useEffect(() => {
		if (isEmpty(codeParams)) {
			return;
		}

		// eslint-disable-next-line
	}, [codeParams]);

	useEffect(() => {
		if (isEmpty(codeParams)) {
			return;
		}
		setCode({
			...code,
			otp1: codeParams[0],
			otp2: codeParams[1],
			otp3: codeParams[2],
			otp4: codeParams[3],
		});
		// eslint-disable-next-line
	}, [codeParams]);

	useEffect(() => {
		if (
			isEmpty(code.otp1) ||
			isEmpty(code.otp2) ||
			isEmpty(code.otp3) ||
			isEmpty(code.otp4)
		) {
			setVisible(false);
		} else {
			setVisible(true);
		}
		// eslint-disable-next-line
	}, [code]);

	const { mutateAsync: handleResetPin, isLoading: resetLoading } =
		useMutation(resetPin);

	const handleReset = async (e) => {
		e.preventDefault();
		const codeData = `${code.otp1}${code.otp2}${code.otp3}${code.otp4}`;
		console.log(code, codeData);
		if (codeData.length !== 4 || isNaN(codeData)) {
			Toast.fire({
				icon: "error",
				title: `Invalid code, Please check again`,
			});
			return;
		}
		if (isEmpty(walletPin.new_pin) || isEmpty(walletPin.confirm_new_pin)) {
			Toast.fire({
				icon: "error",
				title: `Pin cannot be empty`,
			});
			return;
		}
		if (walletPin.new_pin !== walletPin.confirm_new_pin) {
			Toast.fire({
				icon: "error",
				title: `Pin do not match`,
			});
			return;
		}
		const credentials = {
			email: user?.email,
			code: codeData,
			pin: walletPin.new_pin,
		};
		console.log(credentials);

		try {
			const res = await handleResetPin(credentials);
			console.log("reset pin res ", res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: `${res.data.message}\n ${res.data.data}`,
			});
			viewUserProfile();
			setTimeout(() => {
				history.push(ROUTES.SETTINGS);
			}, 500);
		} catch (err) {
			console.log("the reset pin error", err);
		}
	};

	const { mutateAsync: handleForgotPin, isLoading: forgotLoading } =
		useMutation(forgotPin);

	const handleResend = async (e) => {
		e.preventDefault();
		if (!user?.email) {
			return;
		}

		const data = {
			email: user?.email,
		};

		try {
			const res = await handleForgotPin(data);
			console.log("reset pin res ", res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: `${res.data.message}\n ${res.data.data}`,
			});
			setResend(true);
			rcl(true);
			setTimeout(() => {
				rcl(false);
			}, 20000);
		} catch (err) {
			console.log("the forgot pin error", err);
		}
	};

	return (
		<LandingLayout>
			<div tw="h-full flex! flex-col!">
				<Wrapper>
					<ArrowLeftOutlined
						tw="p-3 bg-gray-100 mb-12 rounded-full hover:bg-white"
						onClick={() => history.goBack()}
					/>

					<LandingTitle>Reset Pin</LandingTitle>

					<div tw="pt-8">
						<p tw="text-lg">
							We’ve sent the verification code to <br />
							<b>
								{user?.email
									? user?.email
									: emailParams
									? emailParams
									: "your mail"}
							</b>{" "}
						</p>
					</div>

					<div tw="w-full">
						<form
							tw="flex flex-col sm:w-full md:w-full xl:w-8/12 lg:w-9/12"
							onSubmit={handleReset}>
							<div tw="flex flex-row flex-nowrap items-center justify-between">
								<InputNumber
									name="otp1"
									type="text"
									autoComplete="off"
									value={code.otp1}
									placeholder="-"
									css={otpStyle}
									onChange={(e) => {
										setCode({ ...code, otp1: e });

										console.log(e);
									}}
									tabIndex="1"
									min="0"
									maxLength="1"
									onKeyUp={(e) => inputfocus(e)}
								/>
								<InputNumber
									name="otp2"
									type="number"
									autoComplete="off"
									css={otpStyle}
									value={code.otp2}
									placeholder="-"
									onChange={(e) =>
										setCode({
											...code,
											otp2: e,
										})
									}
									tabIndex="2"
									min="0"
									maxLength="1"
									onKeyUp={(e) => inputfocus(e)}
								/>
								<InputNumber
									name="otp3"
									type="number"
									autoComplete="off"
									css={otpStyle}
									value={code.otp3}
									placeholder="-"
									onChange={(e) =>
										setCode({
											...code,
											otp3: e,
										})
									}
									tabIndex="3"
									maxLength="1"
									min="0"
									onKeyUp={(e) => inputfocus(e)}
								/>
								<InputNumber
									name="otp4"
									type="number"
									css={otpStyle}
									autoComplete="off"
									value={code.otp4}
									placeholder="-"
									onChange={(e) =>
										setCode({
											...code,
											otp4: e,
										})
									}
									tabIndex="4"
									maxLength="1"
									min="0"
									onKeyUp={(e) => inputfocus(e)}
								/>
							</div>
							{visible && (
								<>
									<div>
										<Input.Password
											placeholder="New wallet PIN"
											type="password"
											css={inputStyle}
											maxLength={4}
											value={walletPin.new_pin}
											onChange={(e) => {
												setWalletPin({
													...walletPin,
													new_pin:
														e.target.value.trim(),
												});
											}}
											prefix={
												<img
													src={lock}
													alt=""
													tw="pr-2"
												/>
											}
											iconRender={(visible) =>
												visible ? (
													<EyeTwoTone twoToneColor="#ddd" />
												) : (
													<Image
														preview={false}
														src={pwd_hidden}
														alt=""
														width={20}
														height={20}
													/>
												)
											}
										/>
									</div>
									<div>
										<Input.Password
											placeholder="Confirm New PIN"
											type="password"
											css={inputStyle}
											maxLength={4}
											value={walletPin.confirm_new_pin}
											onChange={(e) => {
												setWalletPin({
													...walletPin,
													confirm_new_pin:
														e.target.value.trim(),
												});
											}}
											prefix={
												<img
													src={lock}
													alt=""
													tw="pr-2"
												/>
											}
											iconRender={(visible) =>
												visible ? (
													<EyeTwoTone twoToneColor="#ddd" />
												) : (
													<Image
														preview={false}
														src={pwd_hidden}
														alt=""
														width={20}
														height={20}
													/>
												)
											}
										/>
									</div>
									<button
										type="submit"
										tw="mt-8 h-12"
										css={btnStyle}>
										{resetLoading ? (
											<Loading />
										) : (
											"Continue"
										)}
									</button>
								</>
							)}

							<div tw="flex flex-row items-center justify-center mt-8 ">
								<Button
									type="link"
									tw="text-base text-appTextDark pr-1"
									onClick={handleResend}
									disabled={resend}>
									Re-send code{" "}
									{resend && <span tw="pl-1">in</span>}
								</Button>
								{rc && (
									<span tw="inline-flex items-center justify-center  text-appPink gap-1">
										<Countdown
											tw="text-sm text-appPink"
											format="m:ss"
											value={Date.now() + 20 * 1000}
											valueStyle={{
												color: COLORS.appPink,
											}}
										/>
									</span>
								)}
							</div>
						</form>
					</div>
				</Wrapper>{" "}
			</div>
			{(resetLoading || forgotLoading) && <PageLoading />}
		</LandingLayout>
	);
};

export default ResetPin;
